import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const PLACEHOLDER = 'https://res.cloudinary.com/demo/image/upload/v1/samples/ecommerce/accessories-bag';

export default function ProductCard({ product }) {
  const { addItem, items } = useCart();
  const inCart = items.some(i => i.uuid === product.uuid);
  const img = product.primary_image || PLACEHOLDER;

  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', transition: 'transform 0.15s, box-shadow 0.15s' }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.14)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = ''; }}>

      {/* Image */}
      <Link to={`/product/${product.uuid}`} style={{ position: 'relative', display: 'block', aspectRatio: '4/3', overflow: 'hidden', background: '#f4f4f4' }}>
        <img src={img} alt={product.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'none'}
          onError={e => { e.target.src = PLACEHOLDER; }} />
        {product.new_arrival === 1 && (
          <span style={{ position: 'absolute', top: 10, left: 10 }} className="badge badge-green">New</span>
        )}
        {product.is_firearm === 1 && (
          <span style={{ position: 'absolute', top: 10, right: 10 }} className="badge badge-firearm">FFL Required</span>
        )}
      </Link>

      {/* Info */}
      <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <div style={{ fontSize: 11, color: '#9a9a9a', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>
          {product.subcategory_name || product.category_name}
        </div>
        <Link to={`/product/${product.uuid}`}>
          <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1a2744', marginBottom: 4, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {product.title}
          </h3>
        </Link>
        {(product.make || product.model) && (
          <div style={{ fontSize: 12, color: '#9a9a9a', marginBottom: 6 }}>{[product.make, product.model].filter(Boolean).join(' ')}</div>
        )}
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 12 }}>
          <div>
            <span className="price">${product.price?.toFixed(2)}</span>
            {product.original_price > product.price && (
              <span className="price-original">${product.original_price?.toFixed(2)}</span>
            )}
          </div>
          <button
            onClick={() => addItem(product)}
            disabled={inCart}
            className={`btn btn-sm ${inCart ? 'btn-ghost' : 'btn-primary'}`}
            style={{ padding: '6px 12px', fontSize: 12 }}>
            {inCart ? '✓ In Cart' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
}
